export default __webpack_public_path__ + "static/media/u_exclamation-circle.ce3d4d93.svg";